import { useTransition, type HTMLAttributes, type ReactNode } from "react";
import { useMatch, useNavigate } from "react-router-dom";

type RenderFunction = (params: {
  isActive: boolean;
  isPending: boolean;
}) => ReactNode;

export function Link({
  children,
  onClick,
  to,
  ...rest
}: Omit<HTMLAttributes<HTMLSpanElement>, "children"> & {
  children?: ReactNode | RenderFunction;
  to: string;
}) {
  const isActive = !!useMatch(to);
  const [isPending, startTransition] = useTransition();
  const navigate = useNavigate();

  return (
    <a
      children={
        typeof children === "function"
          ? children({ isActive, isPending })
          : children
      }
      data-link={to}
      onClick={(event) => {
        onClick?.(event);

        startTransition(() => {
          navigate(to);
        });
      }}
      {...rest}
    />
  );
}
